//import Swagger from 'swagger-client';
//import { handleError, error, receive, request, isUndefinedOrNull } from '../../lib/Utils';
import { callApi } from '../../lib/SwaggerApi';


//let SwaggerApi = new Swagger('/api/docs');

export const UPDATE_SETTINGS = {
  REQUEST: "UPDATE_SETTINGS_REQUEST",
  SUCCESS: "UPDATE_SETTINGS_SUCCESS",
  FAILURE: "UPDATE_SETTINGS_FAILURE"
};


export const GET_SETTINGS = {
  REQUEST: "GET_SETTINGS_REQUEST",
  SUCCESS: "GET_SETTINGS_SUCCESS",
  FAILURE: "GET_SETTINGS_FAILURE"
};

export function updateSettings(formData, callback) {
  return callApi({
    updateSettingsBody: formData
  }, "Business", "updateSettings", UPDATE_SETTINGS, callback);
}
export function getSettings(parameters, callback) {
  return callApi(parameters, "Business", "getSettings", GET_SETTINGS, callback);
}




/*
export const updateSettings = (formData, callback = () => false) => {

  return (dispatch) => {
    dispatch(request(UPDATE_SETTINGS));
    return SwaggerApi.then(client => {
      client.apis.Business.updateSettings({
        updateSettingsBody: formData
      }).then(payload => {
        dispatch(receive(UPDATE_SETTINGS, payload.body));
        callback(null, payload.body);
      }).catch(err => {
        dispatch(error(UPDATE_SETTINGS, err.response.body));
        callback(err.response.body);
      });
    }).catch(err => {
      dispatch(error(UPDATE_SETTINGS, err));
      callback(err);
    });
  };
};
export const getSettings = (parameters, callback = () => false) => {
  return (dispatch) => {
    dispatch(request(GET_SETTINGS));
    return SwaggerApi.then(client => {
      client.apis.Business.getSettings(parameters).then(payload => {
        dispatch(receive(GET_SETTINGS, payload.body));
        callback(null, payload.body);
      }).catch(err => {
        dispatch(error(GET_SETTINGS, err.response.body));
        callback(err.response.body);
      });
    }).catch(err => {
      dispatch(error(GET_SETTINGS, err));
      callback(err);
    });
  };
};
*/


// WEBPACK FOOTER //
// ./src/containers/Settings/SettingsActions.js